import '../assets/css/Home.css';


const Suitemates = () => {
    return (
    <div className="Title">
      <h1>SuiteMates</h1>
     </div>
    );
  };
  
export default Suitemates;